<sc-dialog-title>
  <sc-dictionary-label dictionaryKey="tmc-yard.dialog.transport-option.title"></sc-dictionary-label>
</sc-dialog-title>

<sc-padding>
    <div class="content no-field-space">
        <sc-flex fitHeight stretchContent>
            <sc-flex-fitting-content>
                <sc-flex fitHeight vertical stretchContent>
                    <sc-sub-title>
                      <sc-dictionary-label dictionaryKey="tmc-yard.dialog.transport-option.selected-title"></sc-dictionary-label>
                    </sc-sub-title>
                    <sc-content-spacer vertical></sc-content-spacer>
                    <sc-flex-fitting-content vertical>
                      <sc-scroll-pane>
                          <ng-container *ngFor="let value of selectedValues; let i = index">
                              <sc-content-spacer [half]="true" vertical *ngIf="i>0"></sc-content-spacer>
                              <sc-data-set-tile [light]="i % 2 === 0">
                                  <sc-padding>
                                      <sc-flex >
                                          {{value.label}}
                                          <sc-content-spacer grow></sc-content-spacer>
                                          <sc-action-icon iconClass="fa-minus" (click)="remove(value)"></sc-action-icon>
                                      </sc-flex>
                                  </sc-padding>
                              </sc-data-set-tile>
                          </ng-container>
                      </sc-scroll-pane>
                    </sc-flex-fitting-content>
                </sc-flex>
            </sc-flex-fitting-content>
            <sc-content-spacer></sc-content-spacer>
            <sc-flex-fitting-content>
                <sc-flex fitHeight vertical stretchContent>
                    <sc-sub-title>
                      <sc-dictionary-label dictionaryKey="tmc-yard.dialog.transport-option.available-title"></sc-dictionary-label>
                    </sc-sub-title>
                    <sc-content-spacer vertical></sc-content-spacer>
                    <form [formGroup]="formGroup">
                        <sc-flex >
                            <sc-string-field formControlName="query" grow label="Suche"></sc-string-field>
                        </sc-flex>
                    </form>
                    <sc-content-spacer vertical></sc-content-spacer>
                    <sc-flex-fitting-content vertical>
                      <sc-scroll-pane>
                          <ng-container *ngFor="let value of filteredValues; let i = index">
                              <sc-content-spacer [half]="true" vertical *ngIf="i>0"></sc-content-spacer>
                              <sc-data-set-tile [light]="i % 2 === 0">
                                  <sc-padding>
                                      <sc-flex >
                                          <sc-action-icon iconClass="fa-plus" (click)="add(value)" *ngIf="!value.assigned"></sc-action-icon>
                                          <sc-icon iconClass="fa-square-check"  *ngIf="value.assigned"></sc-icon>
                                          <sc-content-spacer></sc-content-spacer>
                                          {{value.label}}
                                      </sc-flex>
                                  </sc-padding>
                              </sc-data-set-tile>
                          </ng-container>
                      </sc-scroll-pane>
                    </sc-flex-fitting-content>
                </sc-flex>
            </sc-flex-fitting-content>
        </sc-flex>
    </div>
</sc-padding>

<sc-padding>
    <sc-flex >
        <sc-content-spacer grow></sc-content-spacer>
        <button mat-stroked-button (click)="cancel()">
          <sc-dictionary-label dictionaryKey="tmc-yard.action.close"></sc-dictionary-label>
        </button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="confirm()">
          <sc-dictionary-label dictionaryKey="tmc-yard.action.confirm"></sc-dictionary-label>
        </button>
    </sc-flex>
</sc-padding>
